import { endOfMonth, format, startOfMonth, subMonths } from 'date-fns'

import {
  ReportInterval,
  ReportIntervalInput,
  ReportPeriod,
} from '../types/report/report'

const getPeriodStart = (period: ReportPeriod, now: Date): Date => {
  switch (period) {
    case ReportPeriod.TODAY:
      return now
    case ReportPeriod.THIS_MONTH:
      return startOfMonth(now)
    case ReportPeriod.LAST_3_MONTHS:
      return startOfMonth(subMonths(now, 3))
    case ReportPeriod.LAST_6_MONTHS:
      return startOfMonth(subMonths(now, 6))
    case ReportPeriod.LAST_12_MONTHS:
      return startOfMonth(subMonths(now, 12))
    case ReportPeriod.LAST_MONTH:
      return startOfMonth(subMonths(now, 1))
    default:
      return subMonths(now, 1)
  }
}

const getPeriodEnd = (period: ReportPeriod, now: Date): Date => {
  switch (period) {
    case ReportPeriod.LAST_MONTH:
    case ReportPeriod.LAST_3_MONTHS:
    case ReportPeriod.LAST_6_MONTHS:
    case ReportPeriod.LAST_12_MONTHS:
      return endOfMonth(subMonths(now, 1))
    default:
      return now
  }
}

export const isReportIntervalInputValid = ({
  period,
  startDate,
  endDate,
}: ReportIntervalInput): boolean => {
  if (period === ReportPeriod.CUSTOM && (!startDate || !endDate)) {
    return false
  }

  return !startDate || !endDate || startDate <= endDate
}

export const createReportInterval = ({
  period,
  startDate,
  endDate,
}: ReportIntervalInput): ReportInterval => {
  const now = new Date()
  const generatedStart = getPeriodStart(period, now)
  const generatedEnd = getPeriodEnd(period, now)
  const intervalStart = startDate ?? generatedStart
  const intervalEnd = endDate ?? generatedEnd

  return {
    startDate: format(intervalStart, 'yyyy-MM-dd'),
    endDate: format(intervalEnd, 'yyyy-MM-dd'),
  }
}

export const createReportQuery = ({
  startDate,
  endDate,
}: ReportInterval): string =>
  new URLSearchParams({ startDate, endDate }).toString()
